function getShortcuts(clb) {
	window.Liferay.Service(
		'/expandovalue/get-json-data',
		{
			companyId: window.themeDisplay.getCompanyId(),
			className: 'com.liferay.portal.kernel.model.User',
			tableName: 'CUSTOM_FIELDS',
			columnName: 'shortcuts',
			classPK: window.themeDisplay.getUserId(),
		},
		function (response) {
			clb(JSON.parse(response.data));
		}
	);
}

function saveShortcuts(shortcuts, clb) {
	window.Liferay.Service(
		'/expandovalue/add-value',
		{
			companyId: window.themeDisplay.getCompanyId(),
			className: 'com.liferay.portal.kernel.model.User',
			tableName: 'CUSTOM_FIELDS',
			columnName: 'shortcuts',
			classPK: window.themeDisplay.getUserId(),
			data: JSON.stringify(shortcuts),
		},
		function () {
			clb();
		}
	);
}

window.addShortcut = function (serviceName, clb) {
	getShortcuts((userShortCuts) => {
		if (userShortCuts.includes(serviceName)) {
			return;
		}

		userShortCuts.push(serviceName);

		saveShortcuts(userShortCuts, clb);
	});
};

window.removeShortcut = function (serviceName, clb) {
	getShortcuts((userShortCuts) => {
		const index = userShortCuts.indexOf(serviceName);

		if (index === -1) {
			return;
		}

		userShortCuts.splice(index, 1);

		saveShortcuts(userShortCuts, clb);
	});
};

window.shortcutsIncludes = function (serviceName, clb) {
	getShortcuts((userShortCuts) => {
		clb(userShortCuts.includes(serviceName));
	});
};

window.mobileShortcuts = {};

window.ustawKartaBiblioteczna = function (value) {
	window.mobileShortcuts.kartaBiblioteczna = value;
};
